<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          <back-button
            link="/planned-maintenance/inspection-conditions"
          ></back-button>
          Update Inspection Condition
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-4 col-sm-6 col-md-4 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Planned Maintenance</li>
          <li class="breadcrumb-item">
            <router-link :to="`/planned-maintenance/inspection-conditions`"
              >Inspection Conditions</router-link
            >
          </li>
          <li class="breadcrumb-item active" aria-current="page">Update</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Form  -->
    <div class="row">
      <div class="col-md-10 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Condition</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  v-model="form.condition"
                  class="form-control"
                  placeholder="Condition"
                />
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Level</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  v-model="form.level"
                  class="form-control"
                  placeholder="Level"
                />
              </div>
            </div>
            <div class="form mb-0">
              <submit-button
                :isLoading="isLoading"
                @submit="update"
                text="Update"
                style="float: right"
              ></submit-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "Inspection ConditionUpdate",
  data() {
    return {
      form: {
        employee_role_id: "",
        currency_id: "",
      },
      employee_roles: [],
      currencies: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let form = await axios.get(
        `/inspection_conditions/${this.$route.params.inspection_condition_Id}`
      );
      this.form = form.data.data;
      this.isLoading = false;
    },
    async update() {
      try {
        this.isLoading = true;
        this.form.edited_by_id = this.user.id;
        await axios.patch(
          `/inspection_conditions/${this.$route.params.inspection_condition_Id}`,
          this.form
        );
        this.isLoading = false;
        this.$router.push("/planned-maintenance/inspection-conditions");
      } catch (e) {
        this.isLoading = false;
      }
    },
  },
};
</script>
